import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { DeleteCommercialFindingRequest, DeleteCommercialFindingResponse, ListAdminCommercialFindingsRequest, ListCommercialFindingsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminCommercialFindingApi = createApi({
    reducerPath: "adminCommercialFindingApi",
    baseQuery: baseQueryAdminWithAuth,
    tagTypes: ["AdminCommercialFindings"],
    endpoints: builder => ({
        listAdminCommercialFindings: builder.query<ListCommercialFindingsResponse, ListAdminCommercialFindingsRequest>({
            query: body => ({
                url: `commercialfinding/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            }),
            providesTags: ["AdminCommercialFindings"]
        }),
        deleteCommercialFinding: builder.mutation<DeleteCommercialFindingResponse, DeleteCommercialFindingRequest>({
            query: body => ({ url: "commercialfinding/delete", method: "POST", body }),
            invalidatesTags: (_result, error) => error == null ? ["AdminCommercialFindings"] : []
        })
    })
});

export const { useListAdminCommercialFindingsQuery, useDeleteCommercialFindingMutation } = adminCommercialFindingApi;
